import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	onChange: (value: string) => void;
	settingsId: string;
}

export const XApiKeyField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterXApiKey') }], [t]);

	return (
		<FormInput
			testId="XApiKeyField"
			name={`apiKey-${settingsId}`}
			label="xApiKeyLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
});
